import { traverseNodes, Dnode } from "./walker";
import { cleanText } from "./utils";

const ignoredTypes = ["SCRIPT", "STYLE"];

export const extract = (n: Node) => {
  const cache = {};

  const isTextNode = (n: Node) => n.nodeType === Node.TEXT_NODE;
  const isTypeAllowed = (n: Node) => !ignoredTypes.includes(n.nodeName);
  const isContentAllowed = (n: Text) => cleanText(n.wholeText).split(" ").length > 3; // check cache
  const isDuplicate = (n: Text) => (!cache[n.wholeText] ? ((cache[n.wholeText] = true), false) : true);

  return traverseNodes(
    n,
    (n) => isTextNode(n) && !isDuplicate(n as Text) && isContentAllowed(n as Text),
    (n) => !isTypeAllowed(n)
  );
};
